import { inject, Injectable } from "@angular/core";
import { TranslationService, Product, ENV_FILE_TOKEN } from "gast-common-ng2";
import { AUTH_SERVICE_URL_TOKEN } from "../../constants";
/**
 * Class contains Common URL Paths for Portal http requests.
 */
@Injectable({
  providedIn: "root",
})
export class CommonPortalUrlService {
  readonly #authServiceUrl = inject(AUTH_SERVICE_URL_TOKEN, { optional: true });
  readonly #envConfig = inject(ENV_FILE_TOKEN);

  // Method to add parameter to portal links
  getPortalParameterizedUrl(
    url: string,
    product?: Product | null,
    translationService?: TranslationService,
    redirectUrl?: string
  ) {
    const currentUrl = redirectUrl ? redirectUrl : window.location.href;
    const urlObject = new URL(currentUrl);
    // urlObject.searchParams.delete('lang');

    return (
      url +
      "?" +
      "redirect=" +
      encodeURIComponent(urlObject.href) +
      this.getProductParam(product) +
      this.getLangParam(currentUrl, translationService)
    );
  }

  getProductParam(product?: Product | null) {
    return product ? `&product-id=${product}` : undefined;
  }

  getLangParam(currentUrl: string, translationService?: TranslationService) {
    const url = new URL(currentUrl);
    if (url.searchParams.has("lang")) {
      return `&lang=${url.searchParams.get("lang")}`;
    } else if (translationService) {
      return `&lang=${translationService.getCurrentLanguageCode()}`;
    } else {
      return undefined;
    }
  }

  // Portal Account URL
  // LOGIN
  getPortalAccountLoginUrl(
    product: Product | null,
    translationService: TranslationService,
    redirectUrl?: string
  ): string {
    return this.getPortalParameterizedUrl(
      `${this.#envConfig.accountPortalUrl}login`,
      product,
      translationService,
      redirectUrl
    );
  }

  // REGISTER
  getPortalAccountRegisterUrl(product: Product, translationService: TranslationService, redirectUrl?: string): string {
    return this.getPortalParameterizedUrl(
      `${this.#envConfig.accountPortalUrl}register`,
      product,
      translationService,
      redirectUrl
    );
  }

  // SERVICE AUTHENTICATION
  getLogin(): string {
    if (this.#authServiceUrl === "service-licence") {
      return `${this.#envConfig.licenceServiceUrl}api/public/login`;
    }

    return `${this.#envConfig.authServiceUrl}api/public/login`;
  }

  getLogout(): string {
    if (this.#authServiceUrl === "service-licence") {
      return `${this.#envConfig.licenceServiceUrl}api/public/logout`;
    }

    return `${this.#envConfig.authServiceUrl}api/public/logout`;
  }

  getRegister(): string {
    return `${this.#envConfig.authServiceUrl}api/public/register`;
  }

  getUserInfo(): string {
    if (this.#authServiceUrl === "service-licence") {
      return `${this.#envConfig.licenceServiceUrl}api/public/auth/user-info`;
    }

    return `${this.#envConfig.authServiceUrl}api/public/user-info`;
  }

  // DTZ SERVICE AUTHENTICATION
  getDtzLogin(): string {
    return `${this.#envConfig.dtzAuthServiceUrl}api/public/login`;
  }

  getDtzLogout(): string {
    return `${this.#envConfig.dtzAuthServiceUrl}api/public/logout`;
  }

  getDtzRegister(): string {
    return `${this.#envConfig.dtzAuthServiceUrl}api/public/register`;
  }

  getDtzUserInfo(): string {
    return `${this.#envConfig.dtzAuthServiceUrl}api/public/user-info`;
  }
}
